import { ReactNode } from 'react';
import { BadgeCheck, CircleAlert } from 'lucide-react';
import {
  ExternalToast,
  Toaster as LibToaster,
  ToasterProps,
  toast as libToast,
} from 'sonner';

import { Typography } from '@/components/typography/typography';

import { Stack } from '@/lib/shadcn/components/ui/stack/stack';

export const Toaster = (props: ToasterProps) => {
  return <LibToaster {...props} />;
};

const renderSuccessContent = (content: ReactNode) => {
  if (typeof content === 'string') {
    return (
      <Stack
        direction="row"
        align="center"
        justify="center"
        gap={3}
        className="w-full shrink-0"
        data-testid="pop-up-window"
      >
        <BadgeCheck className="size-unit-10 shrink-0 text-teal-500" />
        <Typography.p4 className="text-slate-400">{content}</Typography.p4>
      </Stack>
    );
  }
  return content;
};

const renderErrorContent = (content: ReactNode) => {
  if (typeof content === 'string') {
    return (
      <Stack
        direction="row"
        align="center"
        justify="center"
        gap={3}
        className="w-full shrink-0"
        data-testid="pop-up-window"
      >
        <CircleAlert className="size-unit-10 shrink-0 text-red-500" />
        <Typography.p4 className="text-slate-400">{content}</Typography.p4>
      </Stack>
    );
  }
  return content;
};

const showToast = (content: ReactNode, options?: ExternalToast) => {
  libToast.dismiss();
  return libToast(content, options);
};

export const toast = Object.assign(showToast, {
  dismiss: (id?: string | number) => libToast.dismiss(id),
  error: (content: ReactNode, options?: ExternalToast) => {
    libToast.dismiss();
    return libToast(renderErrorContent(content), options);
  },
  success: (content: ReactNode, options?: ExternalToast) => {
    libToast.dismiss();
    return libToast(renderSuccessContent(content), options);
  },
});
